import React from 'react'
import View from 'components/View'
import './index.css'
import getQuickShadeVariantsProductVariantUtil from 'modules/product-variant/utils/get-quick-shade-variants'
import useSelector from 'hooks/use-selector'
import useDispatch from 'hooks/use-dispatch'
import updateSelectedQuickShadeVariantIdAction from 'modules/variant/redux/actions/update-selected-quick-shade-variant-id'
import getSelectedQuickShadeVariantIdSelector from 'modules/variant/redux/selectors/get-selected-quick-shade-variant-id'
import ProductCardQuickShadesItem from 'components/ProductCard/components/QuickShades/components/Item'
import useIsExtraExtraSmallScreen from 'hooks/use-is-extra-extra-small-screen'
import isAvailableRawProductVariantUtil from 'modules/product-variant/utils/is-available-raw'
import shouldHideShadeUtil from 'components/ProductCard/components/QuickShades/utils/should-hide-shade'

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCardQuickShades ({
  featuredProductVariant
}) {
  const dispatch = useDispatch()
  const featuredVariantId = featuredProductVariant?.variant_id
  const isExtraExtraSmallScreen = useIsExtraExtraSmallScreen()
  const selectedVariantId = useSelector(getSelectedQuickShadeVariantIdSelector(featuredVariantId))

  const {
    /**
     * @type {ProductVariantCollection[]|*}
     */
    quickShadeVariants,
    remainingVariantsCount
  } = getQuickShadeVariantsProductVariantUtil({
    featuredProductVariant,
    isExtraExtraSmallScreen
  })

  let variantIdToUse
  if (isAvailableRawProductVariantUtil(featuredProductVariant)) {
    variantIdToUse = featuredProductVariant.variant_id
  } else {
    variantIdToUse = quickShadeVariants?.find(variant => isAvailableRawProductVariantUtil(variant))?.variant_id
  }

  const selectedVariant = quickShadeVariants?.find(variant => variant.variant_id === selectedVariantId)

  const handleMount = () => {
    dispatch(
      updateSelectedQuickShadeVariantIdAction({
        featuredVariantId,
        value: variantIdToUse
      })
    )
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  return (
    <View className='quick-shades'>
      {
        quickShadeVariants.map((variant) => {
          const itemVariantId = variant.variant_id
          const isSelected = itemVariantId === selectedVariantId

          const shouldHideShade = shouldHideShadeUtil({
            productVariant: variant,
            selectedVariant
          })

          if (shouldHideShade) {
            return null
          }

          return (
            <ProductCardQuickShadesItem
              variant={variant}
              isSelected={isSelected}
              key={itemVariantId}
              featuredVariantId={featuredVariantId}
            />
          )
        })
      }

      {
        remainingVariantsCount > 0 && (
          <View className='quick-shades-more'>
            +{remainingVariantsCount}
          </View>
        )
      }
    </View>
  )
}
